import { IconButtonProps, IconButton, Comp } from '@redsift/design-system';
import React, { forwardRef } from 'react';
import { Tooltip } from './Tooltip';
import { TooltipProps } from './types';
import { TooltipTriggerProps } from '../tooltip-trigger';
import { TooltipContentProps } from '../tooltip-content';

export const IconButtonWithTooltip: Comp<
  {
    tooltip: string;
    tooltipProps?: TooltipProps;
    tooltipTriggerProps?: Omit<TooltipTriggerProps, 'ref'>;
    tooltipContentProps?: Omit<TooltipContentProps, 'ref'>;
  } & Omit<IconButtonProps, 'ref'>,
  HTMLButtonElement
> = forwardRef(({ tooltip, tooltipProps, tooltipTriggerProps, tooltipContentProps, ...props }, ref) => (
  <Tooltip {...tooltipProps}>
    <Tooltip.Trigger {...tooltipTriggerProps}>
      <IconButton aria-label={tooltip} {...props} aria-describedby={undefined} ref={ref} />
    </Tooltip.Trigger>
    <Tooltip.Content {...tooltipContentProps}>{tooltip}</Tooltip.Content>
  </Tooltip>
));
IconButtonWithTooltip.displayName = 'IconButton';
